import apiClient from '../client'

export type AnnouncementType = 'STATIC' | 'AUTO_PAYMENT_REMINDER'

export interface AnnouncementAdmin {
  id: number
  type: AnnouncementType
  title: string
  body: string
  municipalityId: number | null
  displayStartAt: string | null
  displayEndAt: string | null
  filterConfig: { daysBefore?: number } | null
  isActive: boolean
  publishedAt: string
  sortOrder: number | null
}

export type AnnouncementUpsert = Omit<AnnouncementAdmin, 'id'>

export const announcementsApi = {
  list() {
    return apiClient.get<AnnouncementAdmin[]>('/api/admin/announcements')
  },
  create(data: AnnouncementUpsert) {
    return apiClient.post<AnnouncementAdmin>('/api/admin/announcements', data, {
      _suppressToastOnFieldErrors: true,
    })
  },
  update(id: number, data: AnnouncementUpsert) {
    return apiClient.put<AnnouncementAdmin>(`/api/admin/announcements/${id}`, data, {
      _suppressToastOnFieldErrors: true,
    })
  },
  remove(id: number) {
    return apiClient.delete<void>(`/api/admin/announcements/${id}`)
  },
}
